module.exports = require('./lib/Observable.js').Observable;



//////////////////
// WEBPACK FOOTER
// /Users/nathan/dev/piggybk/aws-amplify/node_modules/zen-observable/index.js
// module id = 95
// module chunks = 0 1